export default __webpack_public_path__ + "static/media/why_img_3.4042be25.png";